export default __webpack_public_path__ + "static/media/ADOTNewLogo.967dbb0f.png";